module.exports = __webpack_public_path__ + "img/639-638-plan.8d1bf66d.jpg";